import { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Modal, Alert, CloseButton } from "react-bootstrap";
import { ToastContainer, toast, Slide } from 'react-toastify';
import "../styles/MenuMain.css";
import 'react-toastify/dist/ReactToastify.css';
import southwesternLogo from '../../assets/southwestern-logo-nobg.png';
import { FaCopy } from 'react-icons/fa';

export default function MenuMain() {
    
    useEffect(() => {
        document.title = "DocuQuest Landing Page"; // Set the tab name
    }, []);

    const navigate = useNavigate();
    const [showTrackingModal, setShowTrackingModal] = useState(false);  
    const [trackingNumber, setTrackingNumber] = useState('');
    const [trackingName, setTrackingName] = useState('');

    const [errorTracking, setErrorTracking] = useState({
        type: "",
        message: ""
    });

    const refInput = useRef(null);
    const nameInput = useRef(null);

    const changeTrackingNumber = (event) => {
        const { value } = event.target;
        setTrackingNumber(`REF-${value}`);
    };

    const changeTrackingName = (event) => {
        const { value } = event.target;
        setTrackingName(value);
    };

    const attempt_tracking = (e) => {
        e.preventDefault();

        // console.warn("tracking name: ", trackingName);
        // console.warn("tracking number: ", trackingNumber);
        
        // check for invalid/empty fields in modal
        const refNumberPattern = /^REF-\d{13}-\d{6}$/; // Pattern: REF-XXXXXXXXXXXXX-XXXXXX
        if (!refNumberPattern.test(trackingNumber)) {
            // toast.error("Invalid reference number format. Please check and try again.", {
            //     position: "top-right",
            //     autoClose: 3000,
            //     transition: Slide
            // });

            setErrorTracking({
                type:"danger",
                message: `Invalid reference number format. Please check and try again.`
            })

            refInput.current.focus();
            return;
        }

        if (!trackingName.trim()) {
            // toast.error("Last name of document owner is required to track the request.", {
            //     position: "top-right",
            //     autoClose: 3000,
            //     transition: Slide
            // });

            setErrorTracking({
                type:"danger",
                message: `Last name of document owner is required to track the request.`
            })

            nameInput.current.focus();
            return;
        }

        axios.post('https://docuquest-swu.swucite.tech/api_drts/transactionsOwner.php/', {
            trackingNumber: trackingNumber,
            trackingName: trackingName
        })
        .then((res)=>{
            const found_request = res.data;
            //console.warn("got requests: ", found_request);

            if (res.data.status !== 0) {
                // toast.success("Request found! Redirecting...", {
                //     position: "top-right",
                //     autoClose: 3000,
                //     transition: Slide
                // });            
                
                setErrorTracking({
                    type:"success",
                    message: `Request found! Redirecting...`
                })

                navigate(`/tracking/${trackingNumber}`, { state: {trackingName: trackingName} });
                
                // reset tracking form
                setShowTrackingModal(false);
                setTrackingName('');
                setTrackingNumber('');
            } else {
                // toast.error("Cannot find request. Please check your reference number and last name.", {
                //     position: "top-right",
                //     autoClose: 3000,
                //     transition: Slide
                // });

                setErrorTracking({
                    type:"danger",
                    message: `Cannot find request. Please check your reference number and last name.`
                })

                refInput.current.focus();
                setTimeout(() => nameInput.current.focus(), 100); // Focus on the second input after 100ms
            }
        })
        .catch((err)=>{
            // toast.error("Error searching for request. Please contact the Department of the Registrar about this issue.", {
            //     position: "top-right",
            //     autoClose: 3000,
            //     transition: Slide
            // });

            setErrorTracking({
                type:"danger",
                message: `Cannot find request: ${err}`
            })
        })        
    }

    // function to submit form with enter key without turning button into a submit type
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); 
            attempt_tracking(e);
        }
    };
    
    const copyEmail = () => {
        const email = document.getElementById("txtEmail").textContent;
        navigator.clipboard.writeText(email);
    };

    return (
        <div className='app-wrapper landing'>

                <img 
                    src={southwesternLogo} 
                    alt="Southwestern University Logo" 
                    className="southwestern-logo"
                />

            
            <div>
                <ToastContainer />
                <div className="button-box">
                    <div className="welcome-text">
                        Welcome to DocuQuest System
                    </div>

                    {/* id='request' */}
                    <button className="btn primary-btn" onClick={() => navigate('/request')} title='Request for a document.'>
                        Make a Request
                    </button>

                    {/* id='tracking' */}
                    <button className="btn secondary-btn" onClick={() => setShowTrackingModal(true)} title='Track down a document request.'>
                        Request Tracking
                    </button>

                    <button className="btn secondary-btn" onClick={() => navigate('/login')} title='Login to DocuQuest as a staff member.'>
                        Log in to DocuQuest
                    </button>
                </div>
            </div>

            <section id="contact-box" className="button-box">
                <p className="info-hotline">
                    Having issues with your request?
                    Contact the registrar's office at<br/>
                    <FaCopy/> <span className="hotline" id="txtEmail" title="Click here to copy this email" onClick={copyEmail}> registrar.swu@phinmaed.com</span>
                </p>
            </section>

            <Modal centered show={showTrackingModal} onHide={() => setShowTrackingModal(false)} backdrop='static'>
                <CloseButton onClick={() => setShowTrackingModal(false)} title="Close this modal" />
                <Modal.Header>
                  <Modal.Title>Track a Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="tracking-form" onKeyDown={handleKeyDown}>
                    <div className='title-wrapper'>
                    {errorTracking?.message ? (
                    <Alert variant={errorTracking.type}>
                        {errorTracking.message}
                    </Alert>
                    ) : (
                    <p>Enter your reference&nbsp;number&#32;and the document owner's last&nbsp;name&#32;to track your request.</p>
                    )}

                    </div>
                    
                        <div className="form-group referencenumber-wrapper">
                          <span>REF-</span>
                          <input
                          ref={refInput}
                          required
                          type="tel"
                          name="trackingNumber"
                          className='track-ref'
                          pattern="[0-9]{13}-[0-9]{6}"
                          minLength={20}
                          maxLength={20}
                          placeholder="0000000000000-000000"
                          onChange={changeTrackingNumber}
                        />
                        </div>

                        <input
                        ref={nameInput}
                        required
                        type="text"
                        name="trackingName"
                        className='track-lastname'
                        placeholder="Enter last name of owner"
                        onChange={changeTrackingName}
                        />
                    </form>

                        <button id="btn-track" className="btn primary-btn" type="button" onClick={attempt_tracking} title="Click to track document request." >
                           Track
                        </button>
                </Modal.Body>
            </Modal>
        </div>
    );
}